import { render, staticRenderFns } from "./step6.vue?vue&type=template&id=95f299f2&scoped=true"
import script from "./step6.vue?vue&type=script&lang=ts"
export * from "./step6.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f299f2",
  null
  
)

export default component.exports